export default [
  'BOTCustomMetaTags',
  'BOTContactInfoEVPage'
]

/* Appears on /tires/electric-vehicle-tires */
